import { render, staticRenderFns } from "./ServiceTab.vue?vue&type=template&id=54f9a17c&scoped=true&"
import script from "./ServiceTab.vue?vue&type=script&lang=js&"
export * from "./ServiceTab.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTab.vue?vue&type=style&index=0&id=54f9a17c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9a17c",
  null
  
)

export default component.exports